// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1524":"css/app.7060","6026":"css/admin-app.7060"}[chunkId] + ".css";
};